import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { BookprocessStep } from './components/BookprocessStep';
import { BookprocessSelect } from './components/BookprocessSelect';
import { sendTagManagerEvent, createPurchasePayload } from './components/gtagEvent';
import { bookingInfo } from './components/bookingInfoInterface';
import { StrictMode } from 'react';

const bookprocessElements = document.querySelectorAll('.bookprocess') as NodeListOf<HTMLElement>;
if (bookprocessElements.length === 0) {
    const bookprocessIdElement = document.getElementById('bookprocess'); // fallback
    if (bookprocessIdElement) {
        createBookprocess(bookprocessIdElement);
        bookprocessIdElement.classList.add('bookprocess');
    }
}
for (let bookprocessElement of bookprocessElements) {
    createBookprocess(bookprocessElement);
}

function createBookprocess(bookprocessElement: HTMLElement) {
    const bookProcessId = bookprocessElement.dataset.id;
    const baseUrl = bookprocessElement.dataset.url || '';
    const firstWidgetValue = bookprocessElement.dataset.firstWidgetValue || null;
    const root = createRoot(bookprocessElement!);
    if (bookProcessId) {
        let selfURL = `${baseUrl}/api2/bookprocesses/book/${bookProcessId}`;
        let bookProcessUrl = new URL(selfURL, window.location.toString());

        root.render(
            <StrictMode>
                <BookprocessStep selfURL={bookProcessUrl} firstWidgetValue={firstWidgetValue} />
            </StrictMode>
        );
    } else {
        root.render(<BookprocessSelect />);
    }
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const infoUrl = urlParams.get('infoUrl');

if (infoUrl) {
    fetch(infoUrl)
        .then(resp => {
            return resp.json();
        })
        .then(resp => {
            let info = resp.info as bookingInfo;
            if (info.bookingStatus === 'definitief') {
                sendTagManagerEvent('purchase', createPurchasePayload(info));
            } else if (info.bookingStatus === 'reservering' || info.bookingStatus === 'optie') {
                sendTagManagerEvent('quotation', createPurchasePayload(info));
            }
        });
}
